module.exports = __webpack_public_path__ + "img/antes_despues_294.eb68c1b0.png";